module.exports = __webpack_public_path__ + "static/img/s2model2.e729a0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/model/s2model2.png
// module id = DIZ3
// module chunks = 0